<template>
  <div class="footer-page">
    <div class="header">
      <div class="otherWebsites">
        <span
          @click="
            URLListIndex = 0;
            isShow = !isShow;
          "
          >国务院部门网站<a-icon type="caret-down"
        /></span>
        <span
          @click="
            URLListIndex = 1;
            isShow = !isShow;
          "
          >地方政府网站<a-icon type="caret-down"
        /></span>
        <span
          @click="
            URLListIndex = 2;
            isShow = !isShow;
          "
          >市政府部门网站<a-icon type="caret-down"
        /></span>
        <span
          @click="
            URLListIndex = 3;
            isShow = !isShow;
          "
          >区(县)政府网站<a-icon type="caret-down"
        /></span>
        <span
          @click="
            URLListIndex = 4;
            isShow = !isShow;
          "
          >其他网站<a-icon type="caret-down"
        /></span>
      </div>
      <div class="listss" v-if="isShow">
        <div v-for="(item, index) in URLList[URLListIndex]" :key="index">
          <a :href="item.url" target="_blank">{{ item.title }}</a>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="cell">
        <p class="title">网站信息</p>
        <p class="content">始创于2000年的道吧网，是全球武道行业内最专业、也最活跃的互联网平台。<br/>
          20几年聚集智慧体育行业，以专业与创新为驱动一直领跑中国赛事智慧服务领域，自主研发申请知识产权30多项，覆盖所有赛事赛制，服务范围覆盖全国。
        </p>
      </div>
      <div class="cell">
        <p class="title">联系我们</p>
        <p class="content">电话：023-68631081</p>
        <p class="content" style="margin-top: 10px;">微信：DBM68631081</p>
        <p class="content" style="margin-top: 10px;">技术支持：重庆道吧集团</p>
      </div>
      <div class="platform">
        <div class="qrcodeBox">
            <div class="qrcode">
                <img src="../../assets/MiniProgram.jpg">
                <span>{{$t('道吧小程序')}}</span>
            </div>
            <div class="qrcode">
                <img src="../../assets/OfficialAccount.jpg">
                <span>{{$t('道吧公众号')}}</span>
            </div>
        </div>
      </div>
    </div>
    <div class="footerToolbarColor">
            <div class="footerToolbar">
                 <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">渝ICP备18013677号-1</a>
              <img :src="pliceIcon" style="margin-left: 20px"/>
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noopener noreferrer">渝公网安备 50010702503473号</a>
              <a href=" " target="_blank" style="position: relative;display: inline-block;height: 0px;">
                <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
                <embed width="0" height="0" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
                </a>
            </div>
      </div>
  </div>
</template>
<style lang="scss" scoped>
.footer-page {
  color: #fff;
  /*padding: 30px 10px;*/
  background-image: url('../../assets/footerbg.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 20px;
  background-color: #d60701;
  .header {
    position: relative;
    .listss {
      position: absolute;
      width: 1200px;
      height: 150px;
      background-color: white;
      z-index: 999;
      top: 20px;
      left: 50%;
      margin-left: -600px;
      overflow-x: hide;
      overflow-y: auto;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 10px;
      div {
        width: 25%;
        a {
          color: #000;
          line-height: 28px;
          padding: 10px 0;
          margin: 10px 20px;
        }
      }
    }
    .otherWebsites {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ddd;
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 30px;

      span {
        padding: 0px 20px 20px 20px;
        cursor: pointer;
      }
    }
  }

  .info {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    align-items: flex-start;
    .cell {
      width: 33.33%;
      .title {
        font-size: 16px;
        margin-bottom: 14px;
      }
      .content {
        font-size: 14px;
      }
    }
    .platform {
      text-align: center;
      margin-bottom: 14px;
      .name {
        font-size: 16px;
        margin-top: 14px;
      }
      .enName {
        font-size: 12px;
      }
      p img {
        height: 48px;
      }
    }

    .contact {
      display: flex;
      padding: 20px 0;
      span {
        height: 16px;
        line-height: 16px;
        display: block;
        &:first-child {
          padding-right: 20px;
          border-right: 1px solid #fff;
        }
        &:last-child {
          padding-left: 20px;
        }
      }
    }
  }
  .footer-end {
    width: 1200px;
    margin: 0 auto;
    padding-top: 12px;
    text-align: center;
    border-top: 2px solid hsla(0,0%,100%,.2);
    font-size: 12px;
    .footerCell {
      color: #fff;
      margin-right: 10px;
      margin-bottom: 4px;
      display: inline-block;
    }
  }

  a {
    color: #fff;
  }
  .describe {
    line-height: 30px;
    a {
      margin-right: 30px;
    }
  }
}
.qrcodeBox{
           margin-top: 10px;
       }
       .qrcode{
           display: inline-block;
           margin-right:25px;
           position: relative;
           img{
               width: 120px;
               height: 120px;
              border-radius:10px;
           }
           span{
               display: block;
           }

       }
.footerToolbarColor{
  text-align: center;
    position: relative;
    background-color: rgb(184,0,0);
    .toTop{
        position: absolute;
        width: 160px;
        height: 41px;
        background-color: #000;
        right: 0;
        display: inline-block;
        top: 0;
        -webkit-clip-path: polygon(100% 0, 100% 100%, 0% 100%, 20% 0);
        clip-path: polygon(100% 0, 100% 100%, 0% 100%, 20% 0);
        text-align: center;
        cursor: pointer;
        span{
            font-size: 18px;
            font-weight: 600;
            color: #fff;
            line-height: 41px;
        }
    }
}
</style>

<script>
export default {
  name: 'Home',
  mounted () {
    // 初始化
  },
  data () {
    return {
      title: '底部',
      URLListIndex: 0,
      isShow: false,
      pliceIcon: require('@daoba-match/assets/pliceIcon.png'),
      URLList: [
        [
          // 搞这个链接烦死了！
          { title: '政府网', url: 'http://www.gov.cn/' },
          { title: '国家体育总局', url: 'http://www.sport.gov.cn/' },
          { title: '国防部', url: 'http://www.mod.gov.cn/' },
          { title: '外交部', url: 'https://www.mfa.gov.cn/' },
          { title: '国家发展和改革委员会', url: 'https://www.ndrc.gov.cn/' },
          { title: '教育部', url: 'http://www.moe.gov.cn/' },
          { title: '科学技术部', url: 'http://www.most.gov.cn/' },
          { title: '工业和信息化部', url: 'https://www.miit.gov.cn/' },
          { title: '公安部', url: 'http://www.mps.gov.cn/' },
          { title: '民政部', url: 'http://www.mca.gov.cn/' },
          { title: '司法部', url: 'http://www.moj.gov.cn/' },
          { title: '财政部', url: 'http://www.mof.gov.cn/index.htm' },
          { title: '人力资源和社会保障部', url: 'http://www.mohrss.gov.cn/' },
          { title: '国家民族事务委员会', url: 'https://www.neac.gov.cn/' },
          { title: '自然资源部', url: 'http://www.mnr.gov.cn/' },
          { title: '生态环境部', url: 'http://www.mee.gov.cn/' },
          { title: '住房和城乡建设部', url: 'http://www.mohurd.gov.cn/' },
          { title: '交通运输部', url: 'https://www.mot.gov.cn/' },
          { title: '水利部', url: 'http://www.mwr.gov.cn/' },
          { title: '农业农村部', url: 'http://www.moa.gov.cn/' },
          { title: '商务部', url: 'http://www.mofcom.gov.cn/' },
          { title: '文化和旅游部', url: 'https://www.mct.gov.cn/' },
          { title: '国家卫生健康委员会', url: 'http://www.nhc.gov.cn/' },
          { title: '退役军人事务部', url: 'http://www.mva.gov.cn/' },
          { title: '应急管理部', url: 'https://www.mem.gov.cn/' },
          { title: '人民银行', url: 'http://www.pbc.gov.cn/' },
          { title: '国家税务总局', url: 'http://www.chinatax.gov.cn/' },
          { title: '国家市场监督管理总局', url: 'http://www.samr.gov.cn/' },
          { title: '国家广播电视总局', url: 'http://www.nrta.gov.cn/' },
          { title: '国家统计局', url: 'http://www.stats.gov.cn/' },
          {
            title: '国务院国有资产监督管理委员会',
            url: 'http://www.sasac.gov.cn/'
          },
          { title: '海关总署', url: 'http://www.customs.gov.cn/' }
        ],
        [
          { title: '北京', url: 'http://www.beijing.gov.cn/' },
          { title: '重庆', url: 'http://www.cq.gov.cn/' },
          { title: '天津', url: 'http://www.tj.gov.cn/' },
          { title: '上海', url: 'http://www.shanghai.gov.cn/' },
          { title: '四川', url: 'http://www.sc.gov.cn/' },
          { title: '河北', url: 'http://www.hebei.gov.cn/' },
          { title: '山西', url: 'http://www.shanxi.gov.cn/' },
          { title: '辽宁', url: 'http://www.ln.gov.cn/' },
          { title: '内蒙古', url: 'http://www.nmg.gov.cn/' },
          { title: '吉林', url: 'http://www.jl.gov.cn/' },
          { title: '黑龙江', url: 'http://www.hlj.gov.cn/' },
          { title: '江苏', url: 'http://www.jiangsu.gov.cn/' },
          { title: '浙江', url: 'http://www.zj.gov.cn/' },
          { title: '安徽', url: 'http://www.ah.gov.cn/' },
          { title: '福建', url: 'http://www.fujian.gov.cn/' },
          { title: '江西', url: 'http://www.jiangxi.gov.cn/' },
          { title: '山东', url: 'http://www.shandong.gov.cn/' },
          { title: '湖北', url: 'http://www.hubei.gov.cn/' },
          { title: '湖南', url: 'http://www.hunan.gov.cn/' },
          { title: '河南', url: 'http://www.henan.gov.cn/' },
          { title: '广东', url: 'http://www.gd.gov.cn/' },
          { title: '广西', url: 'http://www.gxzf.gov.cn/' },
          { title: '海南', url: 'http://www.hainan.gov.cn/' },
          { title: '贵州', url: 'http://www.guizhou.gov.cn/' },
          { title: '云南', url: 'http://www.yn.gov.cn/' },
          { title: '西藏', url: 'http://www.xizang.gov.cn/' },
          { title: '陕西', url: 'http://www.shaanxi.gov.cn/' },
          { title: '甘肃', url: 'http://www.gansu.gov.cn/' },
          { title: '新疆', url: 'http://www.xinjiang.gov.cn/' },
          { title: '新疆生产建设兵团', url: 'http://www.xjbt.gov.cn/' },
          { title: '青海', url: 'http://www.qh.gov.cn/' },
          { title: '宁夏', url: 'http://www.nx.gov.cn/' },
          { title: '香港', url: 'http://www.gov.hk/sc/residents/' },
          { title: '澳门', url: 'https://www.gov.mo/zh-hant/' },
          { title: '台湾', url: 'http://www.gwytb.gov.cn/' }
        ],
        [
          { url: 'http://fzggw.cq.gov.cn', title: '市发展改革委' },
          { url: 'http://jw.cq.gov.cn', title: '市教委' },
          { url: 'http://kjj.cq.gov.cn', title: '市科技局' },
          { url: 'http://jjxxw.cq.gov.cn', title: '市经济信息委' },
          { url: 'http://mzzjw.cq.gov.cn', title: '市民族宗教委' },
          { url: 'http://gaj.cq.gov.cn', title: '市公安局' },
          { url: 'http://mzj.cq.gov.cn', title: '市民政局' },
          { url: 'http://sfj.cq.gov.cn', title: '市司法局' },
          { url: 'http://czj.cq.gov.cn', title: '市财政局' },
          { url: 'http://rlsbj.cq.gov.cn', title: '市人力社保局' },
          { url: 'http://ghzrzyj.cq.gov.cn', title: '市规划自然资源局' },
          { url: 'http://sthjj.cq.gov.cn', title: '市生态环境局' },
          { url: 'http://zfcxjw.cq.gov.cn', title: '市住房城乡建委' },
          { url: 'http://cgj.cq.gov.cn', title: '市城市管理局' },
          { url: 'http://jtj.cq.gov.cn', title: '市交通局' },
          { url: 'http://slj.cq.gov.cn', title: '市水利局' },
          { url: 'http://nyncw.cq.gov.cn', title: '市农业农村委' },
          { url: 'http://sww.cq.gov.cn', title: '市商务委' },
          { url: 'http://whlyw.cq.gov.cn', title: '市文化旅游委' },
          { url: 'http://wsjkw.cq.gov.cn', title: '市卫生健康委' },
          { url: 'http://yjj.cq.gov.cn', title: '市应急局' },
          { url: 'http://sjj.cq.gov.cn', title: '市审计局' },
          { url: 'http://zfwb.cq.gov.cn', title: '市政府外办' },
          { url: 'http://gzw.cq.gov.cn', title: '市国资委' },
          { url: 'http://scjgj.cq.gov.cn', title: '市市场监管局' },
          { url: 'http://tyj.cq.gov.cn', title: '市体育局' },
          { url: 'http://tjj.cq.gov.cn', title: '市统计局' },
          { url: 'http://fpb.cq.gov.cn', title: '市扶贫办' },
          { url: 'http://jgswj.cq.gov.cn', title: '市机关事务局' },
          { url: 'http://jrjgj.cq.gov.cn', title: '市金融监管局' },
          { url: 'http://xfb.cq.gov.cn', title: '市信访办' },
          { url: 'http://rmfkb.cq.gov.cn', title: '市人民防空办' },
          { url: 'http://ggzyjyjgj.cq.gov.cn', title: '市公共资源交易监管局' },
          { url: 'http://lyj.cq.gov.cn', title: '市林业局' },
          { url: 'http://yaojianju.cq.gov.cn', title: '市药监局' },
          { url: 'http://zscqj.cq.gov.cn', title: '市知识产权局' },
          { url: 'http://www.liangjiang.gov.cn', title: '两江新区管委会' },
          { url: 'http://ws.cq.gov.cn', title: '万盛经开区管委会' },
          {
            url: 'http://www.dazu.gov.cn/jkq/sqjkq',
            title: '双桥经开区管委会'
          },
          { url: 'http://gxq.cq.gov.cn', title: '高新区管委会' },
          { url: 'http://jkq.cq.gov.cn', title: '重庆经开区管委会' },
          { url: 'http://www.wz.gov.cn/jkq/wzjkq', title: '万州经开区管委会' },
          {
            url: 'http://www.cqcs.gov.cn/jkq/csjkq',
            title: '长寿经开区管委会'
          },
          { url: 'http://gxhzs.cq.gov.cn', title: '市供销合作社' }
        ],
        [
          { url: 'http://www.wz.gov.cn/', title: '万州区' },
          { url: 'http://www.qianjiang.gov.cn', title: '黔江区' },
          { url: 'http://www.fl.gov.cn/', title: '涪陵区' },
          { url: 'http://www.cqyz.gov.cn/', title: '渝中区' },
          { url: 'http://www.ddk.gov.cn/', title: '大渡口区' },
          { url: 'http://www.cqjb.gov.cn', title: '江北区' },
          { url: 'http://cqspb.gov.cn/', title: '沙坪坝区' },
          { url: 'http://www.cqjlp.gov.cn', title: '九龙坡区' },
          { url: 'http://www.cqna.gov.cn/', title: '南岸区' },
          { url: 'http://www.beibei.gov.cn/', title: '北碚区' },
          { url: 'http://www.ybq.gov.cn', title: '渝北区' },
          { url: 'http://www.cqbn.gov.cn/', title: '巴南区' },
          { url: 'http://www.cqcs.gov.cn/', title: '长寿区' },
          { url: 'http://www.jiangjin.gov.cn/', title: '江津区' },
          { url: 'http://www.hc.gov.cn/', title: '合川区' },
          { url: 'http://www.cqyc.gov.cn', title: '永川区' },
          { url: 'http://www.cqnc.gov.cn', title: '南川区' },
          { url: 'http://www.cqqj.gov.cn/', title: '綦江区' },
          { url: 'http://www.cqdz.gov.cn/', title: '大足区' },
          { url: 'https://www.cqstl.gov.cn', title: '铜梁区' },
          { url: 'http://www.bishan.gov.cn', title: '璧山区' },
          { url: 'http://www.cqtn.gov.cn/', title: '潼南区' },
          { url: 'http://www.rongchang.gov.cn/', title: '荣昌区' },
          { url: 'http://www.cqkz.gov.cn', title: '开州区' },
          { url: 'http://www.cqlp.gov.cn/', title: '梁平区' },
          { url: 'http://www.cqwl.gov.cn/', title: '武隆区' },
          { url: 'http://www.cqck.gov.cn/', title: '城口县' },
          { url: 'http://www.cqfd.gov.cn/', title: '丰都县' },
          { url: 'http://www.zhongxian.gov.cn', title: '忠县' },
          { url: 'http://www.cqsdj.gov.cn', title: '垫江县' },
          { url: 'http://www.yunyang.gov.cn', title: '云阳县' },
          { url: 'http://www.cqfj.gov.cn/', title: '奉节县' },
          { url: 'http://wush.cq.gov.cn', title: '巫山县' },
          { url: 'http://www.cqwx.gov.cn/', title: '巫溪县' },
          { url: 'http://www.cqszx.gov.cn', title: '石柱县' },
          { url: 'http://www.cqxs.gov.cn/', title: '秀山县' },
          { url: 'http://www.youyang.gov.cn', title: '酉阳县' },
          { url: 'http://www.psx.gov.cn/', title: '彭水县' }
        ],
        [
          { url: 'http://jjc.cq.gov.cn/', title: '市纪委监委机关' },
          { url: 'https://www.12371.gov.cn/', title: '市委组织部' },
          { url: 'http://cq.wenming.cn/', title: '市委宣传部' },
          { url: 'http://www.cqtzb.gov.cn/', title: '市委统战部' },
          { url: 'http://www.pacq.gov.cn/index.html', title: '市委政法委' },
          { url: 'http://www.cqjgdj.gov.cn/', title: '市委直属机关工委' },
          { url: 'http://www.ccpc.cq.cn', title: '市人大常委会' },
          { url: 'http://www.cqzx.gov.cn', title: '市政协' },
          { url: 'http://cqfy.chinacourt.org', title: '市高法院' },
          { url: 'http://www.cqjcy.gov.cn/', title: '市检察院' },
          { url: 'http://www.cqmg.gov.cn', title: '民革市委会' },
          { url: 'http://www.cqmm.org.cn', title: '民盟市委会' },
          { url: 'http://www.cqmjsw.gov.cn', title: '民进市委会' },
          { url: 'http://www.cqngd.gov.cn/', title: '农工党市委会' },
          { url: 'http://www.cqzgd.gov.cn', title: '致公党市委会' },
          { url: 'http://www.tmcq.gov.cn', title: '台盟市委会' },
          { url: 'http://www.cqgcc.com.cn', title: '市工商联' },
          { url: 'http://www.cqgh.org', title: '市总工会' },
          { url: 'http://www.cqyl.org.cn', title: '团市委' },
          { url: 'http://www.cqwomen.org.cn', title: '市妇联' },
          { url: 'http://www.cqast.cn', title: '市科协' },
          { url: 'http://www.cqskl.com', title: '市社科联' },
          { url: 'http://www.cqwl.org', title: '市文联' },
          { url: 'http://www.cqwriter.com', title: '市作协' },
          { url: 'http://www.cqdpf.org.cn/', title: '市残联' },
          { url: 'http://www.ccpitcq.org/', title: '市贸促会' },
          {
            url: 'http://www.cqredcross.org.cn/index.html',
            title: '市红十字会'
          },
          { url: 'http://www.cqdx.gov.cn', title: '市委党校' },
          { url: 'http://www.redsa.com.cn', title: '市委党史研究室' },
          { url: 'http://www.cqass.net.cn/index/', title: '重庆社科院' },
          { url: 'http://www.3gmuseum.cn', title: '三峡博物馆' },
          { url: 'http://www.hongyan.info', title: '红岩博物馆' },
          { url: 'http://www.cqaas.cn', title: '市农科院' },
          { url: 'http://www.cqac.org.cn', title: '重庆仲裁办' },
          {
            url: 'http://chongqing.chinatax.gov.cn/cqtax/',
            title: '重庆市税务局'
          },
          { url: 'http://chongqing.pbc.gov.cn', title: '人行重庆营管部' },
          { url: 'http://www.csrc.gov.cn/pub/chongqing/', title: '' },
          {
            url: 'http://www.cbirc.gov.cn/branch/chongqing/view/pages/index/index.html',
            title: '重庆保监局'
          },
          { url: 'http://chongqing.customs.gov.cn', title: '重庆海关' },
          { url: 'http://cqca.miit.gov.cn/', title: '市通信管理局' },
          { url: 'http://cq.spb.gov.cn', title: '市邮政管理局' },
          { url: 'http://www.cqdzj.gov.cn', title: '市地震局' },
          { url: 'http://www.966599.com', title: '市烟草专卖局' },
          { url: 'http://www.cqcatr.com', title: '重庆通信研究院' },
          { url: 'http://www.cqksy.cn', title: '市教育考试院' },
          { url: 'http://zfcxjw.cq.gov.cn/gzf/', title: '市公租房管理局' },
          { url: 'http://www.ccle.cn', title: '重庆农村土地交易所' },
          { url: 'http://www.cqgjj.cn', title: '市住房公积金中心' }
        ]
      ]
    }
  },
  methods: {
    onSubmit () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/daoba-match/views/layout/HomeFooter.vue